import React from "react";

import { Form, Formik } from "formik";
import { Grid } from "@material-ui/core";

import { Button, SecondaryButton } from "components/Form";
import { SelectField } from "components/Form/FormikControls";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  ZoomyDialog,
} from "components/MaterialDialog";
import { SplitAllocationForm } from "components/TransactionSplits/SplitAllocationForm";
import { SplitOrigin, SplitType, SplitTypeOptions } from "constants/splits";
import { validateBuyerSplits } from "lib/splits";

interface PendingBuyerSplitAllocation {
  businessId: string;
  amount: string | number;
}

export interface PendingBuyerSplit {
  type: SplitType;
  splits: PendingBuyerSplitAllocation[];
}

interface Props {
  primaryBusinessId: string;
  quantity: number | null;
  initialSplit?: PendingBuyerSplit | null;
  onSave: (split: PendingBuyerSplit) => void;
  onClose: () => void;
}

export const AddBuyerSplitDialog = ({
  primaryBusinessId,
  quantity,
  initialSplit,
  onSave,
  onClose,
}: Props) => {
  const initialValues: PendingBuyerSplit = initialSplit ?? {
    type: SplitType.PERCENTAGE,
    splits: [{ businessId: primaryBusinessId, amount: 1 }],
  };

  const validate = (values: PendingBuyerSplit) =>
    validateBuyerSplits(values.splits, values.type, quantity);

  return (
    <ZoomyDialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle onClose={onClose}>
        {initialSplit ? "Edit" : "Add"} Buyer Split
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        validate={validate}
        onSubmit={values => {
          onSave(values);
          onClose();
        }}
      >
        <Form>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SelectField
                  name="type"
                  label="Type"
                  tooltip="Only Sale Lots can be split by head count."
                  options={SplitTypeOptions}
                  menuPortalTarget={document.body}
                />
              </Grid>
              <SplitAllocationForm splitType={SplitOrigin.BUYER} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <SecondaryButton type="button" onClick={onClose}>
              Cancel
            </SecondaryButton>
            <Button type="submit">Save</Button>
          </DialogActions>
        </Form>
      </Formik>
    </ZoomyDialog>
  );
};
